export default {
    async created() {
        if(this.$store.state.oldCarsLoadedCars  && this.$store.state.oldCarsLoadedCars.length > 0){
            this.oldCarsLoadedData = true;
        }
        if(this.issetUserFriendlyParams){
            this.load = true;
        }
        const startParams = this.$store.state.moduleOldCars.startParams;

        this.filters.verd = [
            startParams.verd.min,
            startParams.verd.max
        ];
        this.filters.argerd = [
            startParams.argerd.min,
            startParams.argerd.max
        ];
        this.filters.ekinn = [
            startParams.ekinn.min,
            startParams.ekinn.max
        ];

        this.getParams(this.filters);
        await this.GET_LIB();

        this.loadUrlParams();

        this.$store.state.filter = this.filters;
        if (typeof this.$route != "undefined") {
            if (this.$route.path == "/tilbodsbilar") {
                this.resetFilter(this.filters);
                this.filters.verdtilbod = true;
            } else {
                //this.filters.verdtilbod = false;
            }
        }

        if (this.$route.name === 'k7Cars') {
            this.filters.k7 = true;
        }
    },
    mounted() {
        this.filtered = this.getFiltered
        //this.GET_LIB();
        this.scrollElem = window;
        setTimeout(() => {
            if (this.$device.ios() && this.$store.state.isApp) {
                this.scrollElem = document.querySelector(
                    "body.ios.app #main > :nth-child(2)"
                );
            }

            this.scrollElem.addEventListener("scroll", this.handleScroll);
            this.scrollElem.addEventListener("scroll", this.loadMore);
        }, 1000);

        this.getAd({
            location: this.searchResult,
            isUsed: 1
        }).then(res => {
            if (res && res.data && res.data.status) {
                this.allAd = res.data.all_ad;
                this.setAdList(this.allAd);
            }
            this.loadSliders = true;
        });
    },
    updated() {
        $("#js-aside-select").trigger("change.select2");
        $("#js-aside-select2").trigger("change.select2");

        if (Object.keys(this.carsInSliders).length > 0) {
            $(".owl-carousel.index-slider").owlCarousel({
                margin: 0,
                autoWidth: true,
                nav: true
            });
        }

        if (this.flokkar.length > 0) {
            $(".owl-carousel.filters-slider-wrap").owlCarousel({
                margin: 15,
                autoWidth: true,
                dots: true
            });
        }

        this.setLastCarPageVisit(this.$route);
    },
    beforeDestroy() {
        this.scrollElem.removeEventListener("scroll", this.handleScroll);
        this.scrollElem.removeEventListener("scroll", this.loadMore);
        this.$store.state.selected_filters_count = 0;
        this.$store.state.filter = {};
        this.$store.state.sub = 0;
        this.$store.state.moduleOldCars.cars.loaded = false;

        const cars = this.$store.state.oldCarsLoadedCars ? this.$store.state.oldCarsLoadedCars.filter(e => !e.ad):[]

        this.setData({
            field: 'moduleOldCars.cars.items',
            data:cars
        })

        this.setShowMenu(false);
    },
}